/**
 * Shadow Design Tokens
 *
 * Shadow-specific token handling that uses the general token utilities.
 * This matches the SCSS core/shadows/_tokens.scss implementation.
 */

import { createTokenExtractor } from '../core/tokens';
import { type ShadowName } from '../values/shadows';

/**
 * Shadow token extractor with type safety
 *
 * Matches SCSS: shadow($name)
 *
 * @param name - The name of the shadow token (must be a valid ShadowName)
 * @param fallback - Optional fallback value
 * @returns CSS var() function for the shadow token
 */
export const shadow = createTokenExtractor<ShadowName>('shadow');

/**
 * Example usage:
 *
 * ```typescript
 * import { shadow } from './shadows';
 *
 * const boxShadow = shadow('floating'); // ✅ Valid shadow name
 *
 * // TypeScript will show error for invalid names:
 * // const invalidShadow = shadow('invalid-name'); // ❌ Type error
 * ```
 */
